module.exports = __webpack_public_path__ + "static/media/intro_background.0a46a507.66ffc2b5.png";